"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiForm, { UiFormAnnotations, UiFormController } from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import i18n from "@/lang";
export class DepartmentInfoForm extends UiFormController {
  constructor() {
    super(...arguments);
    this.department_name = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([{
    required: true,
    message: i18n.t("team_management.department_manager.dialog.department_name.message"),
    trigger: "blur"
  }])
], DepartmentInfoForm.prototype, "department_name", 2);
let AddDepartment = class extends Vue {
  constructor() {
    super(...arguments);
    this.accessMode = "";
    this.dialogLoading = false;
    this.dialog = new UiDialogController();
    this.controller = new DepartmentInfoForm();
    this.departmentId = "";
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  submit() {
    return __async(this, null, function* () {
      try {
        const response = yield API.post(`api://base.auth/api/v1/department`, {
          name: this.controller.department_name,
          parent_id: this.departmentId
        });
        console.dir(response);
        this.$message.success(this.$t("team_management.department_manager.dialog.success"));
      } catch (error) {
        console.log("error", error);
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.close();
      }
    });
  }
  open(id) {
    console.log("open");
    this.departmentId = id;
    this.controller = new DepartmentInfoForm();
    this.dialog.visible = true;
  }
  close() {
    this.dialog.visible = false;
    this.$emit("refresh");
  }
  closeDepartmentDialog() {
    this.dialog.visible = false;
  }
};
AddDepartment = __decorateClass([
  Component({
    components: {
      UiForm,
      UiSubmit,
      UiDialog
    }
  })
], AddDepartment);
export {
  AddDepartment as default
};
